export const utils = {
  formatDate,
  toTypeFormat,
  getDate,
  resetForm,
  getDaysInMonth,
  getParams
}

/**
 * @function 获取浏览器地址的参数
 * @param {String} [name=''] 获取值的key,默认为空,为空时，函数返回json对象
 * @param {String} [url=window.location.href] 地址，默认为浏览器的url
 * @example  getParams('aa', 'https://www.baidu.com?aa=101')       //101
 */
 function getParams(name = '', url = window.location.href){
  let endVal = '';
  if (url.indexOf("?") != -1) {   //判断url中有没有出现?
      let arrs = url.substring(url.indexOf("?") + 1).split('&');  //截取字符串，获取到?后面的那部分内容;以&符号为准，分割成数组
      arrs = arrs.filter(item => item);     //原有数组过滤为空的值
      let obj = {};
      for (let i = 0; i < arrs.length; i++) {
          let index = arrs[i].indexOf("=");
          let keys = arrs[i].substring(0, index);       //第一个等号前面的那部分
          let vals = arrs[i].substring(index + 1);      //第一个等号后面的内容
          if (keys) {     //keys不为空时，追加到obj对象里
              obj[keys] = decodeURI(vals);    //解码输出,值含有中文字符的情况
          }
      }
      if (arrs.length > 0) {  //先判断数组是不是为空，在判断name是不是有值传过来
          if (name) {
              endVal = obj[name] || '';
          } else {
              endVal = obj;
          }
      }
  }
  return endVal;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

function formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (new Date(date).getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  const o = {
    'M+': new Date(date).getMonth() + 1,
    'd+': new Date(date).getDate(),
    'h+': new Date(date).getHours(),
    'm+': new Date(date).getMinutes(),
    's+': new Date(date).getSeconds()
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function toTypeFormat(key, types) {
  let currentItem = types.filter((type) => {
    return key === type.value
  })[0] || {}
  return currentItem.label
}

// 表单重置
function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

//获取当天时间和前一天时间
function getDate(){
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hour = d.getHours();
  var minute = d.getMinutes();
  var minute1 = "0" + minute;
  var minute2 = minute1.substring(minute1.length - 2);
  var second = d.getSeconds();
  var secondTmp = "0" + second;
  var secondNew = secondTmp.substring(secondTmp.length - 2);
  var ds = new Date(d.getTime() - 24 * 60 * 60 * 1000);
  var years = ds.getFullYear();
  var months = ds.getMonth() + 1;
  var days = ds.getDate();
  var hours = ds.getHours();
  var minutes = ds.getMinutes();
  var minute1s = "0" + minutes;
  var minute2s = minute1s.substring(minute1s.length - 2);
  var seconds = d.getSeconds();
  var secondTmps = "0" + seconds;
  var secondNews = secondTmps.substring(secondTmps.length - 2);
  var newDate = year + "-" + month + "-" + day + " " + hour + ":" + minute2 + ":" + secondNew;
  var dates = years + "-" + months + "-" + days + " " + hours + ":" + minute2s + ":" + secondNews
  var dateArr = []
  dateArr.push(dates,newDate)
  return dateArr;
}

//根据某年某月计算出具体日期
function getDaysInMonth(year, month) {
  const daysOfMonth = [];
  month = parseInt(month, 10);
  const lastDayOfMonth = new Date(year, month, 0).getDate();
  for (let i = 1; i <= lastDayOfMonth; i++) {
    if (i < 10) {
      daysOfMonth.push(year+"-"+month+"-"+"0" + i);
    } else {
      daysOfMonth.push(year+"-"+month+"-"+i);
    }
  }
  return daysOfMonth;
}